import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    choseButton: 'Choose',
    discountMention: 'instead of',
    perMonth: ' / month {taxMention}',
    selectedButton: 'Selected',
    trialPeriod: 'month{plural} offered',
    vat: {
      excluded: 'excl. tax',
      included: 'incl. tax',
    },
    yourCurrentOffer: 'Your current offer',
  },
  fr: {
    choseButton: 'Choisir',
    discountMention: 'au lieu de',
    perMonth: '{taxMention} / mois',
    selectedButton: 'Sélectionnée',
    trialPeriod: 'mois offert{plural}',
    vat: {
      excluded: 'HT',
      included: 'TTC',
    },
    yourCurrentOffer: 'Votre offre actuelle',
  },
} as const);
